export default __webpack_public_path__ + "static/media/IMG_20221031_081759_970.edb35118.jpg";